import {
  doFetchList,
  doFetchItemsList,
  doPatchMultipleItems,
  doFetchItemsForSummary,
} from "@/services/session_item.service";
import humps from "lodash-humps";
import { getField, updateField } from "vuex-map-fields";
import createHumps from "lodash-humps/lib/createHumps";
import { snakeCase } from "lodash";
const snakes = createHumps(snakeCase);

export const sessionItemList = {
  namespaced: true,
  state: {
    list: [],
    inProgress: false,
    userSelectedPartIds: [],
    userSelectedSessionItems: [],
    allSessionItems: [],
    itemListForCart: [],
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    setSessionItemList(state, list) {
      state.list = [];
      state.list = list;
    },
    setSessionItemListForCart(state, list) {
      state.itemListForCart = [];
      state.itemListForCart = list;
    },
    setUserPartIds(state, list) {
      if (list && list.length) state.userSelectedPartIds = [...new Set(list)];
      else state.userSelectedPartIds = [];
    },
    setSelectedItems(state, parts) {
      state.userSelectedSessionItems = parts;
    },
    setAllSessionItems(state, parts) {
      if (parts && parts.length) state.allSessionItems = [...new Set(parts)];
      else state.allSessionItems = [];
    },
    inProgress(state, yesOrNo) {
      state.inProgress = yesOrNo;
    },
    updateItemCurrentStructure(
      state,
      {
        fontStyle,
        fontObj,
        colorStyle,
        colorObj,
        processStyle,
        processObj,
        sessionItemId,
      }
    ) {
      let newList = state.list;
      for (let s = 0; s < newList.length; s++) {
        let currentSessionItem = newList[s];
        if (
          sessionItemId != currentSessionItem.id &&
          currentSessionItem?.summaryData?.currentStructure
        ) {
          let currentStructure =
            currentSessionItem?.summaryData?.currentStructure;
          if (currentStructure.elements) {
            for (let e = 0; e < currentStructure.elements.length; e++) {
              let currentElement = currentStructure.elements[e];
              if (
                [undefined, "true", true].includes(
                  currentElement.styleLinked
                ) &&
                (currentElement.colorStyle ||
                  currentElement.processStyle ||
                  currentElement.fontStyle)
              ) {
                if (
                  fontStyle &&
                  currentElement.fontStyle === fontStyle &&
                  fontObj
                )
                  currentElement.font = fontObj;

                if (
                  colorStyle &&
                  currentElement.colorStyle === colorStyle &&
                  colorObj
                )
                  currentElement.color = colorObj;

                if (
                  processStyle &&
                  currentElement.processStyle === processStyle &&
                  processObj
                ) {
                  currentElement.print = processObj;
                  // currentElement.color = colorObj  // commented out when processStyle matched but colorStyle mismatched Its breaking color for elements
                }
              }
            }
          }
        }
      }
      state.list = [];
      state.list = newList;
    },
    updateItemProperty(state, params) {
      let currentList = state.list;
      for (let i = 0; i < currentList.length; i++) {
        let currentItem = currentList[i];
        if (currentItem.id === params.sessionItemId) {
          currentItem = {
            ...currentItem,
            ...params.property,
          };
          currentList[i] = currentItem;
        }
      }
      state.list = [];
      state.list = currentList;
    },
    removeItemFromList(state, partId) {
      if (state.userSelectedSessionItems.indexOf(partId) != -1) {
        state.userSelectedSessionItems.splice(
          state.userSelectedSessionItems.indexOf(partId),
          1
        );
      }
    },
    addItemToList(state, partId) {
      if (state.userSelectedSessionItems.indexOf(partId) == -1) {
        state.userSelectedSessionItems.push(partId);
      }
    },
  },
  actions: {
    fetchListForBuilder: async ({ commit }, { sessionId, selected }) => {
      commit("inProgress", true);
      try {
        commit("setSelectedItems", []);
        let response = await doFetchItemsList({ sessionId, selected });
        if (response && response.length) {
          commit("setSelectedItems", humps(response));
          return humps(response);
        } else if (response && response.length == 0) {
          return null;
        }
        commit("inProgress", false);
        return null;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchList: async ({ commit }, { sessionId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchList({ sessionId });
        if (response && response.length) {
          response = humps(response);
          commit("setSessionItemList", response);
          commit(
            "setUserPartIds",
            response.map((obj) => obj.productPartId)
          );
          commit(
            "setAllSessionItems",
            response.map((obj) => obj.productPartId)
          );
          return { response: response };
        }
        // else if (response && response.length == 0) {
        //   return { response: null };
        // }
        commit("inProgress", false);
        return { response: null };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchItemsForSummary: async ({ commit }, { sessionId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchItemsForSummary({ sessionId });
        if (response && response.length) {
          response = humps(response);
          commit("setSessionItemList", response);
          commit(
            "setUserPartIds",
            response.map((obj) => obj.productPartId)
          );
          commit(
            "setAllSessionItems",
            response.map((obj) => obj.productPartId)
          );
          return { response: response };
        }
        // else if (response && response.length == 0) {
        //   return { response: null };
        // }
        commit("inProgress", false);
        return { response: null };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    fetchItemsForCart: async ({ commit }, { sessionId }) => {
      commit("inProgress", true);
      try {
        let response = await doFetchList({ sessionId });
        if (response && response.length) {
          response = humps(response);
          return { response: response };
        }
        commit("inProgress", false);
        return { response: null };
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    updateItemCurrentStructure: async (
      { commit },
      {
        fontStyle,
        fontObj,
        colorStyle,
        colorObj,
        processStyle,
        processObj,
        sessionItemId,
      }
    ) => {
      commit("inProgress", true);
      try {
        commit("updateItemCurrentStructure", {
          fontStyle,
          fontObj,
          colorStyle,
          colorObj,
          processStyle,
          processObj,
          sessionItemId,
        });
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    // it will patch mulitple session itesm
    updateSessionItems: async ({ commit }, { sessionItems }) => {
      commit("inProgress", true);
      try {
        let response = await doPatchMultipleItems({
          sessionItems: snakes(sessionItems),
        });
        response = humps(response);
        commit("setSessionItemList", response);
        commit(
          "setUserPartIds",
          response.map((obj) => obj.productPartId)
        );
        commit(
          "setAllSessionItems",
          response.map((obj) => obj.productPartId)
        );
        commit("inProgress", false);
        return response;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    updatePropertyInStore: async ({ commit }, { sessionItemId, property }) => {
      commit("inProgress", true);
      try {
        commit("updateItemProperty", { sessionItemId, property });
        return true;
      } catch (err) {
        commit("inProgress", false);
        throw err;
      }
    },
    removeItemFromList: async ({ commit }, { productId }) => {
      commit("removeItemFromList", productId);
    },
    addItemToList: async ({ commit }, { productId }) => {
      commit("addItemToList", productId);
    },
  },
};
